module.exports = __webpack_public_path__ + "assets/img/51e16bc8d9502a0c247dddd0faccfe43.png";